//--------------- IMPORTAÇÕES ---------------//
import { X } from "lucide-react";
import { useContext } from "react";
import { LeadsContext } from "../../context/LeadsContext";
import { exportService } from "../../services";
import Papa from "papaparse";



//--------------- EXPORTAÇÃO DO MODAL IMPORT LEADS ---------------//
export default function ModalExportLeads() {



  //--------------- CRIAÇÃO DE HOOKS ---------------//
  const { isOpenModalExport, setIsOpenModalExport } = useContext(LeadsContext);
  const { search, setSearch } = useContext(LeadsContext);
  const { statusFilter, setStatusFilter } = useContext(LeadsContext);
  const { tagFilter, setTagFilter } = useContext(LeadsContext);
  const { isExporting, setIsExporting } = useContext(LeadsContext);



  //--------------- FUNÇÃO ASSÍNCRONA HANDLE EXPORT LEADS ---------------//
  async function handleExportLeads() {
    setIsExporting(true);
    const response = await exportService(search, statusFilter, tagFilter)
    if (response.data && response.data.leads) {
      // transforma JSON em CSV
      const csv = Papa.unparse(response.data.leads);

      // cria blob e baixa o arquivo
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "leads_export.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      setIsOpenModalExport(false);
    }
    setIsExporting(false);
  }




  //--------------- RETORNO CONDICIONAL DO MODAL IMPORT LEADS ---------------//
  return (
    <>
      {!isOpenModalExport
        ? null
        :
        <>
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-surface-1 border border-white/[0.08] rounded-xl p-6 w-full max-w-md">
              <div className={!isExporting ? "flex justify-between items-center mb-4" : "hidden"}>
                <h2 className="text-xl font-bold">Você deseja exportar suas leads?</h2>
                <button onClick={() => setIsOpenModalExport(false)}><X className="text-white" /></button>
              </div>
              <div className="flex flex-col gap-3">
                <div className={!isExporting ? "flex justify-end gap-3" : "hidden"}>
                  <button onClick={() => setIsOpenModalExport(false)} className="px-4 py-2 bg-surface-3 rounded">Cancelar</button>
                  <button onClick={handleExportLeads} className="px-4 py-2 bg-brand-600 hover:bg-brand-700 rounded">Confirmar</button>
                </div>
                <div className={!isExporting ? "hidden" : "flex justify-center items-center p-3"}>
                  <h1><i class="fas fa-circle-notch fa-spin opacity-70 text-8xl"></i></h1>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}
